import { Configuration, Month } from '@app/core/model/configuration.model';
import { IConfigurationService } from '@app/core/services/interface/IConfigurationService';

export class MockConfigurationService implements IConfigurationService {
  constructor() {}

  getConfiguration(): Promise<Configuration> {
    const promise = new Promise<Configuration>((resolve, reject) => {
      resolve({
        ignoreDriverTypes: [
          'P1APP',
          'HERSD',
          'HERSN',
          'HOUROT',
          'ITMS1',
          'ITMS2',
          'ITMS3',
          'ITMS4',
          'ITMS5',
          'ITMS6',
          'ITMSTD',
          'SALCNS',
        ],
        safetyMileagePaymentAmount: 0.01,
        commitmentMileagePaymentAmount: 0.01,
        deliveryMileagePaymentAmount: 0.01,
        safetyRingPaymentAmount: 0.02,
        commitmentRingPaymentAmount: 0.02,
        deliveryRingPaymentAmount: 0.02,
        emailTemplates: [
          {
            id: 1,
            emailId: 'SOTBonusErrors',
            mode: 'Normal',
            subject: 'TEST: SOT Bonus Errors',
            body: 'This is TEST for SOT Bonus.',
            distributionList:
              'oscar.esquivel@crengland.com,carlos.campos@crengland.com,karla.sanchez@crengland.com',
          },
          {
            id: 2,
            emailId: 'SOTBonusErrors_ReadOnly',
            mode: 'ReadOnly',
            subject: 'TEST: SOT Bonus Errors (ReadOnly)',
            body: 'This is TEST for SOT Bonus.',
            distributionList:
              'oscar.esquivel@crengland.com,carlos.campos@crengland.com,karla.sanchez@crengland.com',
          },
          {
            id: 3,
            emailId: 'SOTBonusPayments',
            mode: 'Normal',
            subject: 'TEST: SOT Bonus Payments',
            body: 'This is TEST for SOT Bonus.',
            distributionList:
              'oscar.esquivel@crengland.com,carlos.campos@crengland.com,karla.sanchez@crengland.com',
          },
          {
            id: 4,
            emailId: 'SOTBonusPayments_ReadOnly',
            mode: 'ReadOnly',
            subject: 'TEST: SOT Bonus Payments (ReadOnly)',
            body: 'This is TEST for SOT Bonus.',
            distributionList:
              'oscar.esquivel@crengland.com,carlos.campos@crengland.com,karla.sanchez@crengland.com',
          },
        ],
        creditPrefix: 'SafeOnTime-{{Month}} Bonus Payment,{{Type}}',
        paymentType: 'MILBONM',
        lastMonthsDisplayable: 4,
        nextMonthsDisplayable: 0,
        enableBonusTabForDrivers: true,
        bonusInformation: [],
      });
    });
    return promise;
  }

  getDisplaypayablemonths(): Promise<Month[]> {
    const promise = new Promise<Month[]>((resolve, reject) => {
      resolve([
        {
          startDate: new Date(2020, 4, 1),
          endDate: new Date(2020, 4, 30, 23, 59, 59, 999),
        },
        {
          startDate: new Date(2020, 5, 1),
          endDate: new Date(2020, 5, 31, 23, 59, 59, 999),
        },
        {
          startDate: new Date(2020, 6, 1),
          endDate: new Date(2020, 6, 30, 23, 59, 59, 999),
        },
        {
          startDate: new Date(2020, 7, 1),
          endDate: new Date(2020, 7, 31, 23, 59, 59, 999),
        },
        {
          startDate: new Date(2020, 8, 1),
          endDate: new Date(2020, 8, 31, 23, 59, 59, 999),
        },
      ]);
    });
    return promise;
  }

  getEndPoint(): string {
    return '/safeandontime/api/v1';
  }
}
